import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import HihglightsBarComponent from './js/highlights-bar.component';
import HighlightsBarLayout from './js/highlights-bar-layout';
import HighlightsBar from './js/highlights-bar';

ComponentsFactory.getInstance().define('highlights-bar', HihglightsBarComponent);

export {
    HighlightsBarLayout,
    HighlightsBar,
};
